import {
  SET_LOADING,
  SET_ALL_AUDITION_LIST,
  SET_ALL_AUDITION_LIST_META,
  SET_PAST_AUDITION_LIST,
  SET_PAST_AUDITION_LIST_META,
  SET_DRAFT_AUDITION_LIST,
  SET_DRAFT_AUDITION_LIST_META,
  SET_CLOSED_AUDITION_LIST,
  SET_CLOSED_AUDITION_LIST_META,
  SET_AUDITION,
  SET_ACTIVE_AUDITION_LIST,
  SET_ACTIVE_AUDITION_LIST_META,
  SET_AUDITION_TAB,
  SET_SELECTED_LOCATION,
} from "../../actions/auditions/types";

const INITIAL_STATE = {
  loading: false,
  allAuditionsList: [],
  allAuditionsListMetaData: null,
  activeAuditionsList: [],
  activeAuditionsListMetaData: null,
  pastAuditionsList: [],
  pastAuditionsListMetaData: null,
  draftAuditionsList: [],
  draftAuditionsListMetaData: null,
  closedAuditionsList: [],
  closedAuditionsListMetaData: null,
  selectedAudition: null,
  selectedAuditionTab: 0,
  selectedLocation: "ALL",
};

const AuditionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ALL_AUDITION_LIST: {
      return {
        ...state,
        allAuditionsList: action.payload,
      };
    }
    case SET_ALL_AUDITION_LIST_META: {
      return {
        ...state,
        allAuditionsListMetaData: action.payload,
      };
    }
    case SET_ACTIVE_AUDITION_LIST: {
      return {
        ...state,
        activeAuditionsList: action.payload,
      };
    }
    case SET_ACTIVE_AUDITION_LIST_META: {
      return {
        ...state,
        activeAuditionsListMetaData: action.payload,
      };
    }
    case SET_PAST_AUDITION_LIST: {
      return {
        ...state,
        pastAuditionsList: action.payload,
      };
    }
    case SET_PAST_AUDITION_LIST_META: {
      return {
        ...state,
        pastAuditionsListMetaData: action.payload,
      };
    }
    case SET_DRAFT_AUDITION_LIST: {
      return {
        ...state,
        draftAuditionsList: action.payload,
      };
    }
    case SET_DRAFT_AUDITION_LIST_META: {
      return {
        ...state,
        draftAuditionsListMetaData: action.payload,
      };
    }
    case SET_CLOSED_AUDITION_LIST: {
      return {
        ...state,
        closedAuditionsList: action.payload,
      };
    }
    case SET_CLOSED_AUDITION_LIST_META: {
      return {
        ...state,
        closedAuditionsListMetaData: action.payload,
      };
    }
    case SET_AUDITION: {
      return {
        ...state,
        selectedAudition: action.payload,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case SET_AUDITION_TAB: {
      return {
        ...state,
        selectedAuditionTab: action.payload,
      };
    }
    case SET_SELECTED_LOCATION: {
      return {
        ...state,
        selectedLocation: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default AuditionReducer;
